// InvoiceStatusFilter.js
import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Chip,
  Typography
} from '@mui/material';

import { fetchInvoiceStatusFilters } from '../../utils/helper';

const InvoiceStatusFilter = ({ 
  value = 'all', 
  onChange, 
  size = 'small', 
  fullWidth = true,
  label = 'Status',
  showIcons = true,
  variant = 'outlined',
  options = null
}) => {
  const [statusOptions, setStatusOptions] = useState({
    all: { label: 'All Status', color: 'default', icon: null }
  });
  const [loading, setLoading] = useState(true);



  // Fetch status options from backend
  useEffect(() => {
    const loadStatusOptions = async () => {
      try {
        setLoading(true);
        const backendOptions = await fetchInvoiceStatusFilters();
        
        if (backendOptions && backendOptions.length > 0) {
          const optionsMap = {
            all: { label: 'All Status', color: 'default', icon: null }
          };
          
          backendOptions.forEach(option => {
            optionsMap[option.value] = {
              label: option.label,
              color: 'default',
              icon: null
            };
          });
          
          setStatusOptions(optionsMap);
        }
      } catch (error) {
        console.error('Error loading invoice status filters:', error);
        // Keep default options on error
      } finally {
        setLoading(false);
      }
    };

    loadStatusOptions();
  }, []);

  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  const renderMenuItem = (statusKey, statusData) => {
    const IconComponent = statusData.icon;
    
    return (
      <MenuItem key={statusKey} value={statusKey}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {showIcons && IconComponent && (
            <IconComponent 
              sx={{ 
                fontSize: '1rem',
                color: statusData.color === 'default' ? 'text.secondary' : `${statusData.color}.main`
              }} 
            />
          )}
          <Typography variant="body2">
            {statusData.label}
          </Typography>
        </Box>
      </MenuItem>
    );
  };

  return (
    <FormControl size={size} fullWidth={fullWidth} variant={variant}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        label={label}
        sx={{
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }
        }}
      >
        {Object.entries(statusOptions).map(([key, data]) => 
          renderMenuItem(key, data)
        )}
      </Select>
    </FormControl>
  );
};

export default InvoiceStatusFilter;